import Styled from 'styled-components';

export const Line = Styled.div`
	position: relative;
    overflow: hidden;
	height: auto;
`;
export const BaseLevelTableRow = Styled.div`

box-sizing: border-box;
display: flex;
justify-content: stretch;
align-items: center;
height: 48px;
background: white;
border-top: 1px solid #e6e6e6;
border-bottom: ${({isLastRow, isExpanded}) => ((isLastRow === true && !isExpanded) || isExpanded ? '1px' : 0)} solid #e6e6e6;
/* z-index: -2; */
${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'z-index:2;' : '')};
${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'position:sticky;' : '')};
${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'top: 36px;' : '')};
padding-left: ${({numberOfParents}) =>
	numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;'}

&:hover {
    cursor: pointer; 
    background-color:#f8f3fe;
}
`;

export const BaseLevelItem = Styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
box-sizing: border-box;
font-size: 13px;
color: #080927;
font-weight: 400;
line-height: normal;
padding-right: 16px;
width: 166px;
height: 100%;
order: ${props => props.order};

span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

abbr {
    text-decoration: none;
}
`;

export const BaseLevelRightItem = Styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
box-sizing: border-box;
font-size: 13px;
color: #080927;
font-weight: 400;
line-height: normal;

padding-right: 16px;
width: 166px;
height: 100%;
order: ${props => props.order};

span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
`;

export const BaseLevelGreyItem = Styled(BaseLevelItem)`
color: #a1a1a1;
`;

export const BaseLevelDetailItem = Styled.div`
display:  grid;
flex:1;
min-width: 166px;
box-sizing: content-box;
height: 100%;

padding-right: 16px;
font-size: 13px;
color: #080927;
align-items: center;
order: ${props => props.order};
abbr {
    text-decoration: none;
}
span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    >div {
        display: flex;
        flex: 1;
        justify-content: flex-start;
        align-items: center;
        

        span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    }
}
`;

export const MainItem = Styled.div`
display: grid;
justify-content: flex-start;
align-items: center;
flex: 1;
height: 100%;
box-sizing: content-box;
min-width: 166px;
font-size: 13px;
color: #080927;
padding-left: 16px;
order: ${props => props.order};
span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        >div {
        display: flex;
        flex: auto;
        justify-content: flex-start;
        align-items: center;
        min-width: 166px;
        

        span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

        p{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    }
        }

abbr{
    text-decoration: none;
}

`;

export const CaretIconWrapper = Styled.div`
box-sizing: border-box;

order: ${props => props.order};
`;
